"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.treeFilter = treeFilter;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const BaseFilter_1 = require("./BaseFilter");
const inputs_1 = require("../../inputs");
function treeFilter(props) {
    return (key) => new TreeFilter(key, props);
}
class TreeFilter extends BaseFilter_1.BaseFilter {
    render(value, setValue, tid, inModal, vertical) {
        const { defaultValue, nothingSelectedText, filterBy = "root", ...props } = this.props;
        return ((0, jsx_runtime_1.jsx)(inputs_1.TreeSelectField, { ...props, label: this.label, values: value, compact: !vertical, labelStyle: inModal ? "hidden" : !inModal && !vertical ? "inline" : "above", sizeToContent: !inModal && !vertical, onSelect: (options) => {
                const values = options[filterBy].values;
                setValue(values.length === 0 ? undefined : values);
            }, nothingSelectedText: nothingSelectedText !== null && nothingSelectedText !== void 0 ? nothingSelectedText : "All", ...this.testId(tid) }));
    }
}
